<app-header></app-header>

<main>
  <div class="content-wrapper">
    <router-outlet></router-outlet>
  </div>
</main>